import React, { Component } from "react";
import Slider from "react-slick";

// Slick Slider'ın varsayılan stillerini import et
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Certificate extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    const { certificates = [], lang } = this.props;
    const NextArrow = ({ onClick }) => (
      <button
        type="button"
        data-role="none"
        className="slick-next slick-arrow"
        onClick={onClick}
      >
        <i className="fas fa-arrow-right"></i>
      </button>
    );

    const PrevArrow = ({ onClick }) => (
      <button
        type="button"
        data-role="none"
        className="slick-prev slick-arrow"
        onClick={onClick}
      >
        <i className="fas fa-arrow-left"></i>
      </button>
    );
    // Slider ayarları (Temadaki col-lg-4, col-md-6 mantığına göre uyarlandı)
    const settings = {
      dots: false, // Alt tarafta noktalar görünsün mü?
      infinite: true, // Sonsuz döngü
      speed: 500, // Kayma hızı
      slidesToShow: 3, // Masaüstünde kaç tane (col-lg-4 olduğu için 3)
      slidesToScroll: 1,
      autoplay: true, // Otomatik kayma
      autoplaySpeed: 3000,
      arrows: true, // Oklar görünsün
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 992, // Tablet / Laptop
          settings: {
            slidesToShow: 2, // col-md-6 mantığı
          },
        },
        {
          breakpoint: 576, // Mobil
          settings: {
            slidesToShow: 1, // col-sm-12 mantığı
          },
        },
      ],
    };

    return (
      <div
        className="ltn__testimonial-area section-bg-1--- bg-image-top pt-115 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  {" "}
                </h6>
                <h1 className="section-title">
                  {lang === "tr" ? "Sertifikalarımız" : "Our Certificates"}
                </h1>
              </div>
            </div>
          </div>

          {/* SLIDER KISMI */}
          {certificates.length > 0 ? (
            // ÖNEMLİ: "ltn__testimonial-slider-5-active" classını kaldırdık!
            // Yerine <Slider> componenti geldi.
            <div className="row">
              {/* Slider, row'un içinde tam genişlikte çalışmalı */}
              <div className="col-12 slick-arrow-1">
                <Slider {...settings}>
                  {certificates.map((c) => (
                    <div key={c.id} className="px-3">
                      {/* px-3: Kartlar birbirine yapışmasın diye biraz boşluk */}
                      <div className="ltn__testimonial-item ltn__testimonial-item-7">
                        <div className="ltn__testimoni-info">
                          <p className="text-center">
                            <a
                              href={c.file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={c.file}
                                alt={c.title}
                                // Yüksekliği sabitlemek görüntü bozulmasını engeller
                                style={{
                                  height: "280px",
                                  objectFit: "contain",
                                  margin: "0 auto",
                                }}
                              />
                            </a>
                          </p>
                          <div className="ltn__testimoni-info-inner justify-content-center">
                            <div className="ltn__testimoni-name-designation">
                              <h5 className="text-center">{c.title}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          ) : (
            <div className="col-12 text-center">
              <p>
                {lang === "tr"
                  ? "Henüz sertifika bulunmamaktadır."
                  : "No certificates found."}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Certificate;
